export default {
    INVALID_PERSONAL_INFO: 0,
    INVALID_ADDRESS: 1,
    INVALID_IDENTITY_INFO: 2,
    UNDER_18_YEARS_OLD: 3,
    INVALID_FINANCIAL_INFO: 4,
    MISMATCH_BETWEEN_FINANCIAL_AND_PERSONAL_INFO: 5,
    INVALID_STORE_WEBSITE: 6,
    INVALID_STORE_DESCRIPTION: 7,
    INVALID_STORE_LOGO: 8,
    INVALID_SCRIPT_IMPLEMENTATION: 9,
    INVALID_AGREEMENT: 10,
    USER_ACCOUNT_BLOCKING: 11,
    JUST_FOR_CHANGE_SETUP_STATUS_ONLY: 12,
}